import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-pop-up-common',
  imports: [CommonModule, TranslateModule, InputGroupModule, InputGroupAddonModule, InputTextModule],
  templateUrl: './pop-up-common.component.html',
  standalone: true,
  styleUrl: './pop-up-common.component.scss'
})
export class PopUpCommonComponent {
  @Input() showConfirm = true;
  @Input() title: string = 'SYSMESER0008';
  @Input() message!: string;
  @Input() btnText: string = 'SYSMESER0011';
  @Input() btnCancelText: string = 'SYSMESER0010'
  @Input() showCancel: boolean = true;
  @Input() copyText: boolean = false;
  @Output() confirmEvent = new EventEmitter();
  @Output() cancelEvent = new EventEmitter();

  private cdr = inject(ChangeDetectorRef)

  copySuccess: boolean = false;
  onConfirm() {
    this.confirmEvent.emit();
  }

  onCancel() {
    this.cancelEvent.emit();
  }

  copy(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        this.copySuccess = true;
        this.cdr.detectChanges();
      });
    } else {
      this.copyToClipboardFallback(text);
      this.copySuccess = true;
      this.cdr.detectChanges();

    }
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
      .then(() => {
        this.copySuccess = true;

      })
      .catch(err => {
        this.copySuccess = false;
      });
  }

  copyToClipboardFallback(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      this.copySuccess = true;
    } catch (err) {
      this.copySuccess = false;
    }

    document.body.removeChild(textarea);
  }
}
